const formMessageError = {
  blurValidation: {
    toError: 'This field is required.',
    toErrorMax: 'This field cannot be greater than 35 characters.',
    fromError: 'This field is required.',
    fromErrorMax: 'This field cannot be greater than 35 characters.',
    amountError: 'Please enter a valid amount.',
    emailError: 'This field is required.',
    emailConfirmError: 'This field is required.',
  },
  formValidation: {
    toError: 'This field is required.',
    toErrorMax: 'This field cannot be greater than 35 characters.',
    fromError: 'This field is required.',
    fromErrorMax: 'This field cannot be greater than 35 characters.',
    amountError: 'Please enter a valid amount.',
    emailError: 'Please enter a valid email address.',
    emailConfirmError: 'Please enter a valid email address.',
    matchError: 'Both emails must match.',
    deliveryError: 'Delivery date is invalid. Please select a date within a year from now.',
    deliveryErrorOldDate: 'Delivery date is invalid. Please do not select a date in the past.',
  },
};

export default formMessageError;
